import beforeUnloadListener from 'yola-editor/src/js/utils/before-unload-listener';

export const reload = () => {
  beforeUnloadListener.remove();
  window.location.reload();
};
